export const FETCH_CLIENTS = 'FETCH_CLIENTS';
export const ADD_CLIENTS_SUCCESS = 'ADD_CLIENTS_SUCCESS';
export const FILL_CLIENTS = 'FILL_CLIENTS';
